// ==================== Expenses.jsx ====================
import React, { useEffect, useState } from "react";
import axios from "axios";
import { CreditCard } from "lucide-react";
// import ExpenseModal from "./ExpensesModal";
import "../Styling/Expenses.css";
import { useAuth } from "../Context/AuthContext";
import { Base_URL } from "../url";


const Expenses = () => {
  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false); // ✅ NEW

  const { user } = useAuth();
const USER_ID = user?.userId;

  const API_URL =
    `${Base_URL}/ExpensesDetails/GetDataUserId`;

  // ---------- STATUS MAPPERS ----------
  const mapApprovalStatus = (status) => {
    if (status === "A") return "Approved";
    if (status === "W") return "Pending";
    return "Rejected";
  };

  const mapPaidStatus = (paid) => (paid ? "Paid" : "Unpaid");

  // ---------- FETCH ----------
  useEffect(() => {
    const fetchExpenses = async () => {
      try {
        const response = await axios.get(API_URL, {
          params: { UserId: USER_ID },
        });

        const apiArray = response?.data?.data || [];

        const formattedExpenses = apiArray.map((item) => {
          const expense = item?.expenses || {};
          return {
            description: expense.descriptionNotes || "-",
            amount: Number(expense.amountSpent) || 0,
            currency: expense.currency || "INR",
            approvalStatus: mapApprovalStatus(expense.approvalStatus),
            paidStatus: mapPaidStatus(expense.paidStatus),
          };
        });

        setExpenses(formattedExpenses);
      } catch (error) {
        console.error("Failed to fetch expenses", error);
        setExpenses([]);
      } finally {
        setLoading(false);
      }
    };

    fetchExpenses();
  }, []);

  const totalAmount = expenses.reduce(
    (sum, exp) => sum + Number(exp.amount || 0),
    0
  );

  if (loading) {
    return (
      <div className="expenses-card finance">
        <p style={{ fontSize: "12px", textAlign: "center" }}>
          Loading expenses...
        </p>
      </div>
    );
  }

  return (
    <>
      <div className="expenses-card finance">
        {/* Header */}
        <div className="expenses-header finance">
          <div className="expenses-icon finance">
            <CreditCard size={18} />
          </div>

          <h4>Monthly Expenses</h4>

          {/* ✅ VIEW ALL BUTTON */}
          <button
            className="view-all-btn"
            onClick={() => setShowModal(true)}
          >
            View All
          </button>
        </div>

        {/* Summary */}
        <div className="expenses-summary">
          <span>This Month</span>
          <strong>₹{totalAmount.toLocaleString()}</strong>
        </div>

        {/* List */}
        <div className="expenses-list">
          {expenses.length === 0 && (
            <p style={{ fontSize: "11px", textAlign: "center" }}>
              No expenses found
            </p>
          )}

          {expenses.map((exp, index) => (
            <div key={index} className="expense-item">
              <div className="expense-top">
                <span className="expense-description">
                  {exp.description}
                </span>

                <span className="expense-amount">
                  {exp.currency === "INR" ? "₹" : exp.currency}{" "}
                  {Number(exp.amount || 0).toLocaleString()}
                </span>
              </div>

              <div className="expense-meta">
                <span
                  className={`status approval ${exp.approvalStatus.toLowerCase()}`}
                >
                  {exp.approvalStatus}
                </span>

                <span
                  className={`status payment ${exp.paidStatus.toLowerCase()}`}
                >
                  {exp.paidStatus}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ✅ MODAL */}
      {/* <ExpenseModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        expenses={expenses}
      /> */}
    </>
  );
};

export default Expenses;
